/* global System */
// register component(s) with react habitat

export default {
  ImageSlider: () =>
    System.import(
      /* webpackChunkName: "ImageSlider" */
      './ImageSlider'
    ),
}
